export const getAlbums = state => state.albums.albums;